/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";
import { Input } from "reactstrap";
import { LI, UL } from "../../../AbstractElements";
import { H_MENU } from "../../../Data/Sidebar/HorizontalMenu";
import { useAppDispatch, useAppSelector } from "../../../Redux-Toolkit/Hooks";
import { BackBtn } from "./BackBtn";
import EmpltyClass from "./EmptyClass";
import ListOfMenu from "./ListOfMenu";
import { setIsClose } from "../../../Redux-Toolkit/Reducers/BookmarkSlice";
import { BookmarkList } from "./BookmarkList";
import { MenuItemChildMenu, MenuItemMenuType, MenuItemType } from "../../../Type/HeaderType";

const Bookmarks = () => {
  const { bookMarkClass, bookmarkDropDown } = useAppSelector((state) => state.bookmark);
  const mainmenu = [...H_MENU];
  const dispatch = useAppDispatch();
  const [searchValue, setSearchValue] = useState<string>("");
  const [searchResult, setSearchResult] = useState<MenuItemType[]>([]);
  const [bookmarkItems, setBookmarkItems] = useState<any>([]);
  const [searchIcon, setSearchIcon] = useState(false);

  const checkSearchResultEmpty = (items: string) => {
    if (!items.length) setSearchIcon(true);
    else setSearchIcon(false);
  };

  useEffect(() => {
    mainmenu.map((menuItems:MenuItemType) => {
      if (menuItems.bookmark) setBookmarkItems(() => [...bookmarkItems, menuItems])
      if (!menuItems.menu) return false;
      menuItems.menu?.filter((mItems: MenuItemMenuType) => {
        if (mItems.bookmark) setBookmarkItems(() => [...bookmarkItems, mItems])
        if (!mItems.menu) return false;
        mItems.menu.filter((subItems: MenuItemChildMenu) => {
          if (subItems.bookmark) {
            subItems.icon1 = mItems.icon1;
            setBookmarkItems((prev: MenuItemChildMenu[]) => [...prev, subItems]);
          }
          if (!subItems.menu) return false;
          return subItems;
        });
        return mItems;
      });
      return menuItems;
    });
  }, []);

  const addFix = () => dispatch(setIsClose(true));
  const removeFix = () => setSearchValue(searchValue);

  const handleSearchKeyword = (keyword: string) => {
    keyword ? addFix() : removeFix();
    let items: any = [];
    setSearchValue(keyword);
    mainmenu.map((menuItems: MenuItemType) => {
      if (menuItems.title.toLowerCase().includes(keyword) && menuItems.type === "link") items = [...items, menuItems]
      if (!menuItems.menu) return false;
      menuItems.menu?.filter((mItems: MenuItemMenuType) => {
        if (mItems.title.toLowerCase().includes(keyword) && mItems.type === "link") {
          menuItems.icon1 = mItems.icon1;
          items = [...items, mItems];
        }
        if (!mItems.menu) return false;
        mItems.menu.filter((subItems: MenuItemChildMenu) => {
          if (subItems.title.toLowerCase().includes(keyword) && subItems.type === "link") {
            subItems.icon1 = mItems.icon1;
            items = [...items, subItems];
          }
          if (!subItems.menu) return false;
          return subItems;
        });
        return mItems;
      });
      checkSearchResultEmpty(items);
      setSearchResult(items);
      return menuItems;
    });
  };

  const removeFixCallback = useCallback((searchVal: string) => {setSearchValue(searchVal)}, []);
  const setCallbackBookmark = useCallback((valueAdd: string) => {setBookmarkItems(valueAdd)}, []);

  return (
    <div className={`onhover-show-div bookmark-flip ${bookmarkDropDown || bookMarkClass ? "active" : ""}`}>
      <div className="flip-card">
        <div className={`flip-card-inner ${bookMarkClass ? "flipped" : ""}`}>
          <BookmarkList bookmarkItems={bookmarkItems} />
          <div className="back">
            <UL>
              <LI>
                <div className="bookmark-dropdown flip-back-content">
                  <Input type="text" placeholder="search..." defaultValue={searchValue} onChange={(e) => handleSearchKeyword(e.target.value)} />
                  <ListOfMenu removeFix={removeFixCallback} bookmarkItems={bookmarkItems} setCallbackBookmark={setCallbackBookmark} searchValue={searchValue} setBookmarkItems={setBookmarkItems} searchResult={searchResult} setSearchResult={setSearchResult}/>
                  <EmpltyClass searchIcon={searchIcon} />
                </div>
              </LI>
              <BackBtn />
            </UL>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bookmarks;
